<template>
  <div class="div" v-loading="loading">
    <div class="div-top" style="margin-top: 10px">
      <!-- <el-button icon="el-icon-plus" type="primary" @click="handleAdd">新建</el-button>
      <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      > -->
      <el-input
        v-model="searchData.Keyword"
        placeholder="请输入设备名称"
        clearable
        style="width: 300px"
      ></el-input>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
      <el-button
        type="warning"
        @click="handleExport"
        style="margin-left: 10px"
        icon="el-icon-download"
        >导出初始化模板</el-button
      >
      <Upload
        :text="'导入初始化数据'"
        style="margin-left: 10px"
        ref="Upload"
        :uploadUrl="
          $rootUrl +
          '/Base_DeviceTreeManage/Device_FixedAssets/ImportDevice_FixedAssetsToDataBase'
        "
        @success="handleSearch"
      ></Upload>
      <el-button
        type="success"
        @click="handleVerify"
        style="margin-left: 10px"
        icon="el-icon-circle-check"
        >资产确认</el-button
      >
      <!-- <el-button type="primary" @click="handleAdd" style="margin-left: 10px"
      icon="el-icon-upload2"
        >导入初始化数据</el-button
      > -->
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <!-- <el-table-column label="" width="50" type="selection"> </el-table-column> -->
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>

        <!-- <el-table-column label="仓库" align="center" prop="StorIdName"> </el-table-column> -->
        <el-table-column
          label="设备编号"
          align="center"
          prop="device_no"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="设备名称"
          align="center"
          prop="device_name"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="设备型号"
          align="center"
          prop="model_number"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="设备规格"
          align="center"
          prop="specification"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="生产厂家名称"
          align="center"
          prop="manufacturer"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="购置价格"
          align="center"
          prop="purchase_price"
          sortable
        >
        </el-table-column>
        <el-table-column label="设备数量" align="center" prop="Num" sortable>
        </el-table-column>
        <el-table-column label="金额" align="center" prop="Amount" sortable>
        </el-table-column>
        <!-- <el-table-column label="折旧方法" align="center" prop="Depreciations">
        </el-table-column>
        <el-table-column label="折旧年限" align="center" prop="DepreciationPeriod">
        </el-table-column>
        <el-table-column label="残值率" align="center" prop="ResidualValueRate">
        </el-table-column> -->
        <el-table-column
          label="资产编号"
          align="center"
          prop="FixedAssetsCode"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="资产名称"
          align="center"
          prop="FixedAssetsName"
          sortable
        >
        </el-table-column>
        <el-table-column label="状态" align="center" prop="Status" sortable>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.Status === 0">未确认</el-tag>
            <el-tag v-else-if="scope.row.Status === 1" type="success"
              >已确认</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import tools from '@/utils/tools.js'
import Token from '@/utils/cache/TokenCache.js'

import Upload from '@/components/Upload/Upload.vue'
import { Loading } from 'element-ui'
export default {
  data() {
    return {
      token: 'Bearer ' + Token.getToken(),
      searchData: {
        Condition: 'device_name',
        Keyword: '',
      },

      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { Upload },
  methods: {
    handleVerify() {
      this.$confirm('此操作将会将设备数据导入到资产信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const loadingInstance = Loading.service({
            fullscreen: true,
            text: '正在确认中...',
          })
          this.$http
            .post('/Base_DeviceTreeManage/Device_FixedAssets/UpdateDate', {})
            .then((resJson) => {
              loadingInstance.close()
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('确认成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleExport() {
      tools.download(
        this.$rootUrl + '/Base/Base_Device/ExportDeviceToExcel',
        '资产设备',
        '.xlsx',
        'get'
      )
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/Base_DeviceTreeManage/Device_FixedAssets/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: this.searchData,
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelection()
            }
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建用户')
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该资产设备, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/Base_DeviceTreeManage/Device_FixedAssets/DeleteData', ids)
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.EditForm.openForm('编辑用户', row)
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
div {
  padding: 0;
}
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 40px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
